import { MedfarDictionariesValidationRuleTypeEnum } from "@/Common/Models/MedfarDictionaries/Enums/MedfarDictionariesValidationRuleTypeEnum";
import { MedfarDictionariesValidationHelper } from "@/ContactDirectory/Helpers/MedfarDictionariesValidationHelper";
import { DirectoryAddress } from "@/ContactDirectory/Models//DirectoryAddress";

export interface IDirectoryAddressValidationResult {
    zipCode: boolean;
    city: boolean;
    streetAddress: boolean;
    state: boolean;
    country: boolean;
    isFormValid: boolean;
}

export class DirectoryAddressValidator {
    private validationHelper: MedfarDictionariesValidationHelper;

    public constructor(validationHelper: MedfarDictionariesValidationHelper) {
        this.validationHelper = validationHelper;
    }

    public validate(model: DirectoryAddress, isFullFormRequired: boolean = false): IDirectoryAddressValidationResult {
        const isZipCodeValid = (!isFullFormRequired && IsNullOrWhiteSpace(model.postalCode)) || this.isZipCodeValid(model.postalCode, model.countryId);
        const isCountryValid = !IsNullOrWhiteSpace(model.countryId);
        const isStateValid = !IsNullOrWhiteSpace(model.stateId);
        const isCityValid = !isFullFormRequired || !IsNullOrWhiteSpace(model.city);
        const isStreetAddressValid = !isFullFormRequired || !IsNullOrWhiteSpace(model.streetAddress);

        let isFormValid = isZipCodeValid && isCountryValid && isStateValid;

        if (isFullFormRequired)
            isFormValid = isFormValid && isCityValid && isStreetAddressValid;

        return {
            zipCode: isZipCodeValid,
            country: isCountryValid,
            state: isStateValid,
            isFormValid: isFormValid,
            city: isCityValid,
            streetAddress: isStreetAddressValid
        };
    }

    private isZipCodeValid(code: string, countryId: string): boolean {
        const rule = this.validationHelper.getValidationRuleForCountryAndRegion(MedfarDictionariesValidationRuleTypeEnum.PostalCode, countryId);
        if (!rule)
            return false;

        const regex = new RegExp(rule.ValidationRegexPattern);
        return regex.test(code);
    }
}
